import React from "react"
import styled from "styled-components"

export default function BackBtn({ content, onClick, customFor }) {
  return (
    <Btn onClick={onClick} className={customFor}>
      {content}
    </Btn>
  )
}

const Btn = styled.button`
  width: 160px;
  height: 50px;
  background-color: rgba(0, 0, 0);
  backdrop-filter: blur(5px);
  position: relative;

  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% calc(0% + 30px),
    100% 100%,
    0% 100%
  );
  font-size: 16px;
  transition: 0.3s;
  color: #00fff0;
  cursor: pointer;
  border: 1px solid #00fff0;
  &::before {
    content: "";
    position: absolute;
    right: -10px;
    top: 3px;
    width: 50px;
    height: 10px;
    transform: rotate(45deg);
    background-color: #00fff0;
    z-index: 1;
  }

  &:hover {
    background-color: #00fff0;
    color: #000;
    box-shadow: 0px 0px 30px #00fff0;
  }
  &.WEB3Plus {
    border: 1px solid #4646f5;
    color: #fff;
    clip-path: polygon(0% 0%, calc(100% - 50px) 0%, 100% 100%, 0% 100%);
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: -50px;
    }
    &::before {
      content: "";
      position: absolute;
      right: -31px;
      top: 20px;
      width: 100px;
      height: 10px;
      transform: rotate(45deg);
      background-color: #4646f5;
      z-index: 1;
    }
    &:hover {
      background-color: #000000;
      color: #fff;
    }
  }
`
